<template>
  <div class="dsfa-sc-inform-center">
    <DsfSCPanel title="通知中心">
      <el-table
        class="dsfa-sc-inform-center-table"
        :data="list"
        style="width: 100%"
        @row-click="toUrl"
      >
        <el-table-column prop="type" width="120"> </el-table-column>
        <el-table-column prop="title"></el-table-column>
        <el-table-column prop="name" width="120"> </el-table-column>
        <el-table-column prop="date" width="140"> </el-table-column>
      </el-table>
    </DsfSCPanel>
  </div>
</template>

<script>
import dataList from "_statistics-cloud/public/pd_attributes/pc/dsf.scinformcenter.json";
export default dsf.component({
  name: "DsfSCInformCenter",
  ctrlCaption: "通知中心",
  mixins: [$mixins.control],
  data() {
    return {
      list: dataList,
    };
  },
  components: {},
  created() {
    this.$http.get("/static/data/dsf.scinformcenter.json").then(({ data }) => {
      this.list = data.dataList;
    });
  },
  methods: {
    toUrl({ url, openType }, column, event) {
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
  },
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/informCenter.scss';
</style>